
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface PricingHeroProps {
  onTechstarsClick: () => void;
  onOtherClick: () => void;
}

const PricingHero = ({ onTechstarsClick, onOtherClick }: PricingHeroProps) => {
  return (
    <section className="container mx-auto px-6 py-20 text-center">
      <div className="max-w-4xl mx-auto">
        <Badge className="mb-6 bg-blue-100 text-blue-800">Closed Beta - Accelerator Members Only</Badge>
        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
          <span className="text-blue-600">Free Access</span> for Accelerator Startups
        </h1>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          We believe in supporting the startup ecosystem. Get full access to ScoutLink.ai's 
          AI-powered fundraising platform - completely free for verified accelerator members.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size="lg" 
            className="text-lg px-8 py-4"
            onClick={onTechstarsClick}
          >
            Techstars Members Apply Here
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="text-lg px-8 py-4"
            onClick={onOtherClick}
          >
            Other Accelerators Apply
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PricingHero;
